// Documentation ----> https://popper.js.org/
import React from 'react';
import './PopupMenuItem.scss';

const PopupMenuItem = (props) => {
    const { label, icon, children, onClick, smallText, className, noRadius, disabled, subLabel, selected, justifyContent, style, suffix } = props;
	
	return (
		<div className={`popup-menu-item-wrapper${smallText ? " popup-menu-item-small" : ""}${noRadius ? " popup-menu-item-no-radius" : ""}${disabled ? " popup-menu-item-disabled" : ""}${selected ? " selected" : ""}${className ? " " + className : ""}${justifyContent ? " justify-content-" + justifyContent : ""}`}
			onClick={onClick}
			style={style}
		>
			{icon && <div className="popup-menu-item-icon-wrapper">{icon}</div>}
			{suffix ?
				<div className="popup-menu-item-label" style={{ display: 'flex' }}>
					{label ? label : children}
					{suffix}
				</div> :
				<div className="popup-menu-item-label">
					{label ? label : children}
					{subLabel && <div className="popup-menu-item-sub-label">{subLabel}</div>}
				</div>
			}
		</div>
	);
};

export default PopupMenuItem;